import moment from 'moment';

export const isYouthAthlete = (DOB) => {
  if (!DOB) {
    return false;
  }

  const maxYouthAge = moment()
    .subtract(18, 'years')
    .format('YYYY-MM-DD');

  return moment(DOB).isAfter(maxYouthAge);
};
